import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyService } from '@app/_components/property/property.service';
import { CompendiumShortTermRentalJoinService } from '../compendiums-short-term-rental-join.service';
import { CompendiumService } from '@app/_components/compendium/compendium.service';
import { CompendiumShortTermRentalJoin } from '../compendiums-short-term-rental-join';

@Component({
    selector: 'app-compendiums-short-term-rental-join',
    templateUrl: './compendiums-short-term-rental-join.component.html',
    styleUrls: ['./compendiums-short-term-rental-join.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class CompendiumShortTermRentalJoinComponent implements OnInit {
	chargeTypes: any;
	feeTypes: any;
	compendiumId: any;
	shortTermRentalId: any;
	properties: any[]=[];
	compendiums: any[]=[];
	feeFrequencies: any;
	compendiumShortTermRentalFlag = false;
	applyStaysOfNtsList: any[]=[];
	locationTypes: any;
	locationAreas: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private compendiumShortTermRentalJoinService: CompendiumShortTermRentalJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private compendiumService: CompendiumService,
		private propertyService: PropertyService,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title,
			this.compendiumId = data?.compendiumId,
			this.shortTermRentalId = data?.shortTermRentalId,
			this.compendiumShortTermRentalFlag = data?.compendiumShortTermRentalFlag;
			this.compendiumShortTermRentalJoin = data.compendiumShortTermRentalJoin,
			this.statuses = compendiumShortTermRentalJoinService.statuses;
			this.locationTypes = compendiumService.locationTypes;
			this.locationAreas = compendiumService.locationAreas;
	}

	@Input() compendiumShortTermRentalJoin: CompendiumShortTermRentalJoin;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	compendiumShortTermRentalJoinId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		compendiumId: [{ type: 'required', message: 'Required' }],
		shortTermRentalId: [{ type: 'required', message: 'Required' }],
		'description': [],
		'status': [],
		'locationType': [],
		'locationArea': [],
		'featureName': [],
		feature: [],
		featureSortOrder: [],
		featureNameSortOrder: [],
		externalUrl: [],
		

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();
		this.fetchCompendiums();

		// if we were passed the whole compendiumShortTermRentalJoin object
		if (this.compendiumShortTermRentalJoin) {
			this.compendiumShortTermRentalJoinId = this.compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId;
			this.fixDates();
			this.form1.patchValue(this.compendiumShortTermRentalJoin);
			// this.form1.patchValue({
			// 	description: this.compendiumShortTermRentalJoin?.compendium?.description,
			// 	locationType: this.compendiumShortTermRentalJoin?.compendium?.locationType,
			// 	locationArea: this.compendiumShortTermRentalJoin?.compendium?.locationArea,
			// 	featureName: this.compendiumShortTermRentalJoin?.compendium?.featureName,
			// 	feature: this.compendiumShortTermRentalJoin?.compendium?.feature,
			// 	featureSortOrder: this.compendiumShortTermRentalJoin?.compendium?.featureSortOrder,
			// 	featureNameSortOrder: this.compendiumShortTermRentalJoin?.compendium?.featureNameSortOrder,
			// 	externalUrl: this.compendiumShortTermRentalJoin?.compendium?.externalUrl,
			// });

			
		}
	}

	fetchCompendiums() {
		try {
			this.compendiumService.findAllCompendiums()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.compendiums = res.data.compendiums;
						return this.compendiums;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						
						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.compendiumShortTermRentalJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.compendiumShortTermRentalJoinService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.compendiumShortTermRentalJoin = res.data.compendiumShortTermRentalJoin;
						this.doAdd.emit(this.compendiumShortTermRentalJoin);
					},
					(err: any) => {
						console.log('compendiumShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('compendiumShortTermRentalJoin: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.compendiumShortTermRentalJoinService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.compendiumShortTermRentalJoin = res.data.compendiumShortTermRentalJoin;
						this.doUpdate.emit(this.compendiumShortTermRentalJoin);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.compendiumShortTermRentalJoinService.deleteCompendiumShortTermRentalRelationship(this.compendiumShortTermRentalJoin.compendiumId, this.compendiumShortTermRentalJoin.shortTermRentalId)
				.subscribe(
					(res: any) => {
						console.log('compendiumShortTermRentalJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.compendiumShortTermRentalJoin);
					},
					(err: any) => {
						console.log('compendiumShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			compendiumId: [this.compendiumId, Validators.required],
			shortTermRentalId: [this.shortTermRentalId, Validators.required],
			status: ['0'],
			description: ['', Validators.required],
			locationType: [],
			locationArea: [],
			featureName: [],
			feature: [],
			featureSortOrder: [],
			featureNameSortOrder: [],
			externalUrl: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.compendiumShortTermRentalJoin.compendiumShortTermRentalJoinDate = moment(this.compendiumShortTermRentalJoin.compendiumShortTermRentalJoinDate).toDate();
	}

	increasePercentage(percentagefield) {
		let updatedValue = this.form1.value[percentagefield] + 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
	decreasePercentage(percentagefield){
		let updatedValue = this.form1.value[percentagefield] - 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
}
